import React from 'react';
import PropTypes from 'prop-types';
import styles from './StickyCategories.module.sass';

function Category(props) {
  const { name, img, link } = props;
  return (
    <div className={styles.category}>
      <a href={link}>
        <span>{ name }</span>
        <img src={img} alt={name} />
      </a>
    </div>
  );
}

Category.propTypes = {
  name: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default Category;
